<div class="modal-header">
  <h4 class="modal-title">Video Preview</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  ></button>
</div>

<div class="modal-body">
  <ng-container *ngIf="isValidUrl; else invalidBlock">
    <!-- MP4 Video -->
    <video *ngIf="isMp4" controls width="100%">
      <source [src]="safeVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <!-- YouTube Embed -->
    <iframe
      *ngIf="!isMp4"
      [src]="safeVideoUrl"
      width="100%"
      height="315"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </ng-container>

  <!-- Invalid URL -->
  <ng-template #invalidBlock>
    <div class="alert alert-warning text-center">
      🚫 Please provide a valid video URL (YouTube or .mp4).
    </div>
  </ng-template>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="modal.close('Close click')"
  >
    Close
  </button>
</div>
